import {
  BackgroundContainer,
  MainContainer,
  Title,
  TopContainer,
  Column,
  TopTitle,
  Description,
  IconContainer,
  SmallColumn,
  LogoIcon,
  CaseStudyContainer,
  CaseStudyCard,
  CaseStudyImg,
  CaseStudyDesc,
  CaseStudyWrapper,
  CaseStudyImgWrapper,
  Deckcontainer,
  DeckWrapper,
  DeckCard,
  DeckImg,
  DeckText,
  DeckLink,
  HiringContainer,
  HiringButton,
  MerchContainer,
  MerchBanner,
  FontButton,
  TokpedButton,
  FontLogoButton,
  ShopeeButton,
  VideoContainer,
  Video,
  Icon,
  VideoWrapper,
  BookButton,
  BookIcon,
  LogoButton,
} from "./App.styled";
import igIcon from "./assets/instagram.svg";
import linkedinIcon from "./assets/linkedin.svg";
import whatsappIcon from "./assets/whatsapp.svg";
import logo from "./assets/logo.svg";
import hacktiv8 from "./assets/hacktiv8.png";
import pmi from "./assets/pmi.png";
import siloam from "./assets/siloam.png";
import deckNTMY from "./assets/ntmy.png";
import deckVanguard from "./assets/vanguard.png";
import linkIcon from "./assets/vector.svg";
import tokpedIcon from "./assets/tokopedia.svg";
import shopeeIcon from "./assets/shopee.svg";
import Banner from "./assets/banner.png";
import vidcam from "./assets/videocam.png";


function App() {
  return (
    <BackgroundContainer>
      <MainContainer>
        <TopContainer>
          <LogoIcon
            src={ logo }
           alt="ntmy-logo"/>
          <Column>
            <TopTitle>Nice To Meet You Studio</TopTitle>
            <Description>
              Langganan jasa desain grafis untuk kebutuhan harian bisnis kamu ✌️
            </Description>
          </Column>
          <SmallColumn>
            <IconContainer>
                <a
                  href="https://instagram.com/nicetomeetyou.studio"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <Icon src={igIcon} alt="ig-icon"/>
                </a>
                <a
                  href="https://www.linkedin.com/company/nicetomeetyoustudio"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <Icon src={linkedinIcon} alt="linkedin-icon"/>
                </a>
                <a
                  href="https://wa.me/6282170270229?text=Hello%20NTMY!%20I%20would%20like%20to%20know%20more%20about%20your%20plans%20%26%20pricing%20%F0%9F%98%8A"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  style={{ textDecoration: "none", color: "black" }}
                >
                  <Icon src={whatsappIcon} alt="whatsapp-icon"/>
                </a>
              </IconContainer>
          </SmallColumn>
        </TopContainer>

        <CaseStudyContainer>
          <Title>Case Study</Title>
          <CaseStudyWrapper>
            <CaseStudyCard
            href= "https://nicetomeetyou.studio/blog/case-study/how-hacktiv8-advances-their-design-needs-and-marketing-strategy-simultaneously-without-increasing-headcount/?utm_source=NTMY+Links&utm_medium=Media+Social&utm_campaign=Case+Study+Hacktiv8"
            target="_blank"
            rel="nofollow noopener noreferrer">
              <CaseStudyImgWrapper>
                <CaseStudyImg src={hacktiv8} alt="hacktiv-8-case-study" rel="preload"/>
              </CaseStudyImgWrapper>
              <CaseStudyDesc>
                Hacktiv8 coding bootcamp ramps up their design needs for 2 years without hiring extra
              </CaseStudyDesc>
            </CaseStudyCard>
            <CaseStudyCard
            href= "https://nicetomeetyou.studio/blog/case-study/how-infographics-simplifies-philip-morris-internationals-decade-long-digital-transformation-strategy-to-all-employees-around-the-globe/?utm_source=NTMY+Links&utm_medium=Media+Social&utm_campaign=Case+Study+PMI"
            target="_blank"
            rel="nofollow noopener noreferrer">
              <CaseStudyImg src={pmi} alt="philip-morris-international-case-study" rel="preload"/>
              <CaseStudyDesc>
                How PMI effectively communicates a transformation strategy to 70,000 employees worldwide
              </CaseStudyDesc>
            </CaseStudyCard>
            <CaseStudyCard
            href= "https://nicetomeetyou.studio/blog/case-study/how-siloam-hospitals-optimizes-digital-channel-infiltrations-while-increasing-operational-cost-effectiveness-2/?utm_source=NTMY+Links&utm_medium=Media+Social&utm_campaign=Case+Study+Siloam"
            target="_blank"
            rel="nofollow noopener noreferrer">
              <CaseStudyImg src={siloam} alt="siloam-hospital-case-study" rel="preload"/>
              <CaseStudyDesc>
                Siloam Hospitals succeed to maximize the marketing channels of 40 hospitals in the most cost-effective way
              </CaseStudyDesc>
            </CaseStudyCard>
          </CaseStudyWrapper>
        </CaseStudyContainer>
        <Deckcontainer>
          <Title>Our Services</Title>
          <DeckWrapper>
            <DeckCard href ="https://bit.ly/ntmy-deck"
            target="_blank"
            rel="nofollow noopener noreferrer"
            alt="nice-to-meet-you-deck">
              <DeckImg src={deckNTMY} rel="preload"/>
              <DeckLink>
                <DeckText>VIEW</DeckText>
                <img src={linkIcon} width="18px" height="18px" alt="ntmy-deck-link-arrow"/>
              </DeckLink>
            </DeckCard>
            <DeckCard href ="https://bit.ly/vanguard-intro-deck"
            target="_blank"
            rel="nofollow noopener noreferrer"
            alt="vanguard-deck">
              <DeckImg src={deckVanguard} rel="preload"/>
              <DeckLink>
                <DeckText>VIEW</DeckText>
                <img src={linkIcon} width="18px" height="18px" alt="vanguard-deck-link-arrow"/>
              </DeckLink>
            </DeckCard>
          </DeckWrapper>
          <BookButton href="https://nicetomeetyou.studio/booking/?utm_source=NTMY+Links&utm_medium=Media+Social&utm_campaign=NTMY+Form"
          target="_blank"
          rel="nofollow noopener noreferrer"
          style={{textDecoration: "none"}}>
            <BookIcon src={vidcam} alt="booking-icon"/>SCHEDULE A CALL
          </BookButton>
        </Deckcontainer>

        <VideoContainer>
          <VideoWrapper>
            <Video
            src="https://www.youtube.com/embed/RnrM46MZVZg?autoplay=1&mute=1&loop=1&controls=1"
            title="Nice reels vol.2"
            loading="lazy"></Video>
          </VideoWrapper>
        </VideoContainer>
        <HiringContainer>
          <Title>We’re Hiring</Title>
          <HiringButton
          href="https://nicetomeetyou-team.freshteam.com/jobs"
          target="_blank"
          rel="nofollow noopener noreferrer">
            <FontButton>VISIT CAREER SITE</FontButton>
          </HiringButton>
        </HiringContainer>
        <MerchContainer>
          <Title>Nice Merch</Title>
          <MerchBanner src={Banner} loading="lazy"/>
          <TokpedButton
          href="https://www.tokopedia.com/nicetomeetyoustudio"
          target="_blank"
          rel="nofollow noopener noreferrer">
            <LogoButton src={tokpedIcon} alt="tokopedia-logo" loading="lazy"/>
            <FontLogoButton>NTMY CALENDAR 2023</FontLogoButton>
          </TokpedButton>
          <ShopeeButton
          href="https://shopee.co.id/nicetomeetyou.studio"
          target="_blank"
          rel="nofollow noopener noreferrer">
            <LogoButton width="auto" src={shopeeIcon} alt="shopee-logo" loading="lazy"/>
            <FontLogoButton>NICE MERCH</FontLogoButton>
          </ShopeeButton>
        </MerchContainer>
      </MainContainer>
    </BackgroundContainer>
  );
}

export default App;
